import { useFetch } from './index';
import services from '../services';

export const useDesignMaterial = () =>{
    return useFetch(services.DesignMaterial.getDesigns);
}
